import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Checkbox } from "@/components/ui/checkbox";
import { Cloud, Lock, FileCheck2 } from "lucide-react";

const EnvToggle = ({ label, value, onChange, testid, icon: Icon, disabled }) => (
  <label className={`flex items-center gap-2 border p-2 cursor-pointer transition-colors ${value ? "bg-[#F0FDF4] border-[#6EE7B7]" : "bg-[#FEF2F2] border-[#FCA5A5]"}`}>
    <Checkbox disabled={disabled} data-testid={testid} checked={value} onCheckedChange={v => onChange(!!v)} />
    {Icon && <Icon className="w-3.5 h-3.5 text-gray-600" />}
    <span className="text-sm">{label}</span>
  </label>
);

export default function EnvironmentSection({ envState, setEnvState, readOnly }) {
  return (
    <div>
      <Label className="text-xs uppercase tracking-wider font-semibold text-gray-700 flex items-center gap-2"><Cloud className="w-3.5 h-3.5" />Environmental &amp; Site Conditions</Label>
      <div className="mt-2 grid grid-cols-1 md:grid-cols-3 gap-2">
        <EnvToggle disabled={readOnly} testid="env-weather" label="Weather conditions safe" value={envState.weather_ok} onChange={v => setEnvState({ ...envState, weather_ok: v })} />
        <EnvToggle disabled={readOnly} testid="env-area" label="Work area secured" value={envState.area_secured} onChange={v => setEnvState({ ...envState, area_secured: v })} icon={Lock} />
        <EnvToggle disabled={readOnly} testid="env-permits" label="Permits obtained" value={envState.permits_obtained} onChange={v => setEnvState({ ...envState, permits_obtained: v })} icon={FileCheck2} />
      </div>
      <Textarea disabled={readOnly} data-testid="env-notes" value={envState.environmental_notes} onChange={e => setEnvState({ ...envState, environmental_notes: e.target.value })} placeholder="Environmental notes (optional)…" className="rounded-md mt-2 text-sm" />
    </div>
  );
}
